function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,40%,60%)",
      fillOpacity: 1
    },
    d: "M 4.050781 0 L 22.949219 0 C 25.1875 0 27 1.8125 27 4.050781 L 27 22.949219 C 27 25.1875 25.1875 27 22.949219 27 L 4.050781 27 C 1.8125 27 0 25.1875 0 22.949219 L 0 4.050781 C 0 1.8125 1.8125 0 4.050781 0 Z M 4.050781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.605469 4.640625 C 8.542969 6.382812 5.273438 9.914062 5.589844 12.023438 C 5.90625 14.132812 9.070312 15.820312 10.492188 16.929688 C 8.648438 17.875 6.328125 19.300781 6.382812 21.148438 C 6.484375 23.679688 9.226562 22.886719 10.390625 22.148438 C 11.546875 21.410156 12.710938 19.351562 11.96875 17.191406 C 13.605469 16.769531 15.03125 17.296875 15.453125 17.613281 C 17.085938 18.773438 16.242188 20.09375 15.664062 20.304688 C 15.082031 20.515625 15.453125 20.617188 15.820312 20.515625 C 16.1875 20.40625 16.980469 19.882812 16.980469 18.984375 C 16.980469 16.71875 14.554688 15.664062 11.546875 16.453125 C 9.808594 14.609375 7.4375 13.765625 7.539062 11.757812 C 7.59375 11.023438 7.859375 9.125 12.550781 6.75 C 17.242188 4.375 20.566406 5.328125 20.144531 7.488281 C 19.511719 10.757812 13.816406 12.972656 11.8125 11.074219 C 11.707031 10.863281 11.335938 10.703125 11.546875 11.285156 C 12.601562 13.921875 21.148438 12.710938 21.515625 7.117188 C 21.621094 4.164062 17.351562 3.375 13.605469 4.640625 Z M 9.070312 21.515625 C 7.75 21.9375 7.804688 21.09375 7.859375 20.777344 C 8.015625 19.882812 8.753906 18.773438 10.96875 17.664062 C 11.601562 19.671875 10.179688 21.199219 9.070312 21.515625 Z M 9.070312 21.515625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass);
export default __webpack_public_path__ + "static/media/sass.84cf8015339e35ad22fe467f30e1918b.svg";
export { ForwardRef as ReactComponent };